import React, { useState } from 'react';
import FloorMap from './FloorMap';
import floorLayouts from '../data/floorLayouts';

function ThemeVoting({ userId, onComplete }) {
  const [showSecretMission, setShowSecretMission] = useState(false);
  // Hardcoded theme data for display only
  const themes = [
    { id: 1, name: 'Time (Cycle)', quote: '"The cavalry\'s here, luv"', author: 'Tracer', subtitle: 'Killing is a cycle' },
    { id: 2, name: 'Reboot//Glitch', quote: '"and I show you how deep the rabbit hole goes."', author: 'Morpheus', subtitle: '' },
    { id: 3, name: 'Isolation', quote: '"Tut Tut... You\'re Becoming Hysterical."', author: 'Working Joe', subtitle: '' },
    { id: 4, name: 'Forked', quote: '"Now I want your gone"', author: 'GladOS', subtitle: '' },
    { id: 5, name: 'Christmas//Gift', quote: '"All I want for Christmas is…"', author: 'Mariah Carey', subtitle: '' },
    { id: 6, name: 'Limited controls (hostile takeover)', quote: '"I\'m sorry Dave, I\'m afraid I can\'t do that"', author: 'Hal', subtitle: 'I wouldn\'t say freed, more like under new management' },
    { id: 7, name: 'Break the 4th wall', quote: '"That\'s the expression of someone who\'s died twice in a row"', author: 'Sans', subtitle: '' },
    { id: 8, name: 'Take the Heat//Sun (Solarpunk)', quote: '"The city must survive"', author: 'Frostpunk', subtitle: 'There\'s a zombie on your lawn' },
    { id: 9, name: 'Ads', quote: '"Hear the wish of the oppressed /To at least get to be oppressed in style"', author: 'SAMURAI', subtitle: '' },
    { id: 10, name: 'Ozymandias (Entropy)', quote: '"I met a traveller from an antique land who said…"', author: 'Percy Shelby', subtitle: 'How unlucky to have been born at the end of the universe' }
  ];

  if (showSecretMission) {
    const terminalNode = {
      id: 'terminalnode',
      name: 'Terminal Node',
      floor: 5,
      x: 225,
      y: 40,
      type: 'character'
    };

    return (
      <div className="min-h-screen p-4">
        <div className="scanline"></div>
        <div className="max-w-4xl mx-auto">
          <div className="bg-dark-lighter rounded-lg shadow-neon-red border border-cyber-red/30 p-8">
            <div className="text-center mb-8">
              <div className="text-6xl mb-4">🎯</div>
              <h2 className="text-4xl font-bold text-cyber-red mb-2 font-mono glitch">
                [CLASSIFIED] SECRET_TARGET
              </h2>
              <p className="text-cyber-blue text-lg font-mono">
                &gt;&gt; Final objective located - Floor 5
              </p>
            </div>

            <div className="bg-dark border border-cyber-red/50 p-4 rounded-lg text-cyber-red text-center mb-6">
              <p className="text-lg font-semibold font-mono">
                [MISSION] Locate and scan the Terminal Node
              </p>
            </div>

            <div className="bg-dark-lighter rounded-lg border border-cyber-red/30 p-4 mb-6">
              <h3 className="text-cyber-blue text-center font-mono mb-4 text-xl">
                [MAP] FLOOR_05 - TERMINAL_LOCATION
              </h3>
              <FloorMap
                floor={5}
                currentPosition={null}
                targetPosition={terminalNode}
                pathNodes={[terminalNode]}
                floorLayouts={floorLayouts}
              />
            </div>

            <div className="text-center">
              <button
                onClick={onComplete}
                className="bg-cyber-red text-white text-xl 
                         font-bold font-mono px-12 py-4 rounded-lg hover:shadow-neon-red transform 
                         hover:scale-105 transition-all duration-200
                         border-2 border-cyber-red hover:bg-transparent hover:text-cyber-red"
              >
                [ACKNOWLEDGE] →
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen p-4">
      <div className="scanline"></div>
      <div className="max-w-4xl mx-auto">
        <div className="bg-dark-lighter rounded-lg shadow-neon-green border border-primary/30 p-8">
          <div className="text-center mb-8">
            <div className="text-6xl mb-4">🔓</div>
            <h2 className="text-4xl font-bold text-primary mb-2 font-mono glitch">
              [DATABASE] UNLOCKED
            </h2>
            <p className="text-cyber-blue text-lg font-mono">
              &gt;&gt; Archived theme proposals revealed
            </p>
          </div>

          <div className="mb-8">
            <div className="bg-dark border border-primary/50 p-4 rounded-lg text-primary text-center mb-6">
              <p className="text-lg font-semibold font-mono">
                [REWARD] Decrypted theme archives - Read only
              </p>
            </div>

            <div className="space-y-4">
              {themes.map((theme) => (
                <div
                  key={theme.id}
                  className="p-5 rounded-lg border-2 border-primary/30 bg-dark hover:border-primary transition-all duration-200"
                >
                  <div className="flex items-start gap-3">
                    <div className="text-3xl">🔐</div>
                    <div className="flex-1">
                      <div className="text-xs font-semibold mb-2 font-mono text-cyber-blue">
                        [ARCHIVE_{String(theme.id).padStart(2, '0')}]
                      </div>
                      <h3 className="font-bold text-primary text-lg mb-2 font-mono">
                        {theme.name}
                      </h3>
                      <p className="text-matrix-green font-mono text-sm mb-1">
                        {theme.quote} <span className="text-cyber-blue">- {theme.author}</span>
                      </p>
                      {theme.subtitle && (
                        <p className="text-primary/60 font-mono text-xs mt-2">
                          {theme.subtitle}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="text-center">
            <button
              onClick={() => setShowSecretMission(true)}
              className="bg-primary text-dark text-xl 
                       font-bold font-mono px-12 py-4 rounded-lg hover:shadow-neon-green transform 
                       hover:scale-105 transition-all duration-200
                       border-2 border-primary hover:bg-transparent hover:text-primary"
            >
              [ACCESS] NEXT_TARGET →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ThemeVoting;
